import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ConfigClient } from '../httpClients/ConfigClient';
import { GetConfigResponse } from '../httpClients/ConfigClient/api.schema';
import { QUERY_KEYS } from './consts';

type ConfigQueryOptions = Omit<
  Partial<UseQueryOptions<GetConfigResponse>>,
  'queryKey' | 'queryFn'
>;

type RepoIdentity = { provider: string; fullName: string };

/**
 * Hook to fetch settings for the current user's workspace.
 * When `repo` is provided, per-repo overrides are deep-merged on top of the
 * workspace blob server-side; the queryKey carries the repo identity so
 * react-query refetches whenever the picker selection changes.
 * Response is a flat { config: { key: value } } — no transform needed.
 */
export const useConfigQuery = (
  repo?: RepoIdentity | null,
  options?: ConfigQueryOptions,
) =>
  useQuery({
    queryKey: [
      QUERY_KEYS.CONFIG,
      repo?.provider ?? null,
      repo?.fullName ?? null,
    ],
    queryFn: () => ConfigClient.getSettings(repo ?? undefined),
    retry: 1,
    ...options,
  });
